import { Table } from 'antd';
import { ApproveReturnModalWrapper } from './ApproveReturnConfirmDialogStyled';

export type TApproveReturnDialogType = 'APPROVE' | 'RETURN' | null;

export type TApproveReturnDialogLabels = {
  approveConfirmTitle: string;
  returnConfirmTitle: string;
  approveConfirm: string;
  returnConfirm: string;
  approveBtn: string;
  returnBtn: string;
  cancelBtn: string;
  columnLabel: string;
  columnValue: string;
  rowStoreLabel: string;
  rowSessionLabel: string;
};

interface ApproveReturnConfirmDialogProps {
  open: boolean;
  loading: boolean;
  type: TApproveReturnDialogType;
  labels: TApproveReturnDialogLabels;
  sessionDisplay: string;
  /** Single store name/code — pass this OR bulkSummary, not both (店舗=全て uses bulkSummary). */
  storeSummary?: string | null;
  /** 店舗=全て: eligibleCount/totalCount (e.g. "12/20件") per SM mock's x/total display. */
  bulkSummary?: { eligibleCount: number; totalCount: number } | null;
  onCancel: () => void;
  onOk: () => void;
}

function formatTarget(
  storeSummary: string | null | undefined,
  bulkSummary: { eligibleCount: number; totalCount: number } | null | undefined
): string {
  if (storeSummary) {
    return storeSummary;
  }
  if (bulkSummary) {
    return `${bulkSummary.eligibleCount}/${bulkSummary.totalCount - 1}件`;
  }
  return '-';
}

// Confirm dialog for 承認/差し戻し — used by VAMS_PC_004 (FixedAssetLedger), single store or
// bulk (店舗=全て). Formerly VAMS_PC_009_01 on ProgressReviewPage, moved here since PC009 no
// longer has an approval action.
export function ApproveReturnConfirmDialog({
  open,
  loading,
  type,
  labels,
  sessionDisplay,
  storeSummary,
  bulkSummary,
  onCancel,
  onOk,
}: ApproveReturnConfirmDialogProps) {
  const isApprove = type === 'APPROVE';
  const columns = [
    {
      title: labels.columnLabel,
      dataIndex: 'label',
      key: 'label',
      width: '40%',
    },
    { title: labels.columnValue, dataIndex: 'value', key: 'value' },
  ];
  const summaryRows = [
    {
      key: 'store',
      label: labels.rowStoreLabel,
      value: formatTarget(storeSummary, bulkSummary),
    },
    {
      key: 'session',
      label: labels.rowSessionLabel,
      value: sessionDisplay || '-',
    },
  ];

  return (
    <ApproveReturnModalWrapper
      open={open}
      title={isApprove ? labels.approveConfirmTitle : labels.returnConfirmTitle}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onCancel}
      cancelText={labels.cancelBtn}
      okText={isApprove ? labels.approveBtn : labels.returnBtn}
      onOk={onOk}
      width={480}
    >
      <p className="approve-return-confirm_message">
        {isApprove ? labels.approveConfirm : labels.returnConfirm}
      </p>
      <Table
        dataSource={summaryRows}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
    </ApproveReturnModalWrapper>
  );
}
